// @flow
import UsersPage from './UsersPage';
export default UsersPage;



// WEBPACK FOOTER //
// ./src/view/Pages/UsersPage/index.js